import script from "./LotesCategoria.vue?vue&type=script&setup=true&lang=js"
export * from "./LotesCategoria.vue?vue&type=script&setup=true&lang=js"

import "./LotesCategoria.vue?vue&type=style&index=0&id=f79aef5e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f79aef5e"]])

export default __exports__